import { render, staticRenderFns } from "./FoodDistributionRoutes.vue?vue&type=template&id=3aff7d9d&"
import script from "./FoodDistributionRoutes.vue?vue&type=script&lang=js&"
export * from "./FoodDistributionRoutes.vue?vue&type=script&lang=js&"
import style0 from "./FoodDistributionRoutes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports